export const FAQContent = [
    {
        id : 1,
        ques : "What Are The Different TheCarzilla.in Services Available?",
        ans : "TheCarzilla.in provides a diverse range of services:Challan Check & Pay, Car Service History, RTO Records service, Connected Cars for safety, doorstep Car Servicing, Car Health Check , Roadside Assistance and more for expert evaluation. Enjoy a seamless car care journey with us."
    },
    {
        id : 2,
        ques : "Why Should I Choose TheCarzilla.in Services?",
        ans : (
            <>
            There are several reasons to choose TheCarzilla.in services:
            <ol>
            <li>Hassle-free experience: We aim to provide a seamless and convenient car ownership and maintenance experience.</li>
            <li>Data Privacy: We prioritize the security and privacy of your information, ensuring it is handled with the utmost care.</li>
            <li>Fair Price: Our services are competitively priced, offering you value for your money.</li>
            <li>Doorstep Services: Enjoy the convenience of doorstep services with a single click.</li>
            </ol>
            </>
        )
    },
    {
        id : 3,
        ques : "Does TheCarzilla.in Fulfill These Services?",
        ans : "Yes, TheCarzilla.in directly fulfills some of the services, while others are carried out by our partner vendors. We work closely with trusted partners to ensure that all services meet our high standards of quality and customer satisfaction."
    },
    {
        id : 4,
        ques : "Can I Receive Updates/Reminders For My Car Service?",
        ans : "Absolutely! At TheCarzilla.in, we understand the importance of timely car service reminders and updates. We provide notifications for all significant milestones related to your service, including successful booking, cancellation, and completion. This way, you can stay informed and up-to-date throughout the entire process."
    },
    {
        id : 5,
        ques : "How Can I Cancel A TheCarzilla.in Service?",
        ans : (
            <>
                To cancel a TheCarzilla.in service, follow these steps:
                <ol>
                  <li>Go to the "My Orders" section on our platform.</li>
                  <li>Locate the specific order that you wish to cancel.</li>
                  <li>Click on the order to access the order details page.</li>
                  <li>Look for the option to "cancel order." This option will be available as long as the status of the service reads "In progress."</li>
                  <li>Click on the "cancel order" option to initiate the cancellation process.</li>
                </ol>
                Please note that the availability of the cancel option may vary depending on the specific service you have booked.
            </>
        )
    }
]